import dayjs from 'dayjs';

// The API refuses a dispatch load digest spanning more days than this.
export const LOAD_DIGEST_MAX_RANGE_IN_DAYS = 60;

export default function isLoadDigestRangeAllowed(
  startDate: string | null | undefined,
  endDate: string | null | undefined,
) {
  if (!startDate || !endDate) {
    return false;
  }

  const rangeInDays =
    dayjs.tz(endDate).startOf('day').diff(dayjs.tz(startDate).startOf('day'), 'day') + 1;

  return rangeInDays >= 1 && rangeInDays <= LOAD_DIGEST_MAX_RANGE_IN_DAYS;
}
